import { useState, useEffect } from "react";

const useScrollTrigger = (top: number = 30): boolean => {
  const [triggered, setTriggered] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const isPastThreshold = window.scrollY > top;
      setTriggered((prev) => {
        if (prev !== isPastThreshold) return isPastThreshold;
        return prev; // don't trigger unnecessary re-renders
      });
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // check on mount in case already scrolled

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [top]);

  return triggered;
};

export default useScrollTrigger;
